import { isEmpty } from 'lodash'
import { AllClinicsAvailabilitiesGroupedByPeriod, AvailabilitiesPeriod } from '@context/AppointmentCalendarContext/types'
import { isCurrentPeriodEmpty } from '../isCurrentPeriodEmpty'

export const getCurrentPeriod = (
  clinicsAvailabilities?: AllClinicsAvailabilitiesGroupedByPeriod | undefined,
  periodRangeStart?: string,
  previousPeriodLength?: number
): AvailabilitiesPeriod | undefined => {
  if (!isEmpty(clinicsAvailabilities)) {
    const clinicsAvailabilitiesWithFirstPeriod: AvailabilitiesPeriod = {}
    const indexOfFirstPeriodWithAvailabilities = getIndexOfFirstPeriodWithAvailabilities(clinicsAvailabilities)
    Object.entries(clinicsAvailabilities).forEach(([id, clinicAvailabilities]) => {
      clinicsAvailabilitiesWithFirstPeriod[id] = clinicAvailabilities[indexOfFirstPeriodWithAvailabilities]
    })

    if (periodRangeStart) {
      const isWithinRange = Object.values(clinicsAvailabilities).every((weeks) =>
        weeks.some((week) => week.some((day) => day.date === periodRangeStart))
      )
      const previousPeriodDifferentLength =
        (previousPeriodLength || 0) !== Object.keys(clinicsAvailabilitiesWithFirstPeriod).length

      if (!isWithinRange) return

      const indexOfWeek = Object.values(clinicsAvailabilities)[0]?.findIndex((week) =>
        week.some((day) => day.date === periodRangeStart)
      )

      const newPeriod: AvailabilitiesPeriod = Object.entries(clinicsAvailabilities).reduce((previous, current) => {
        const [clinicId, availabilities] = current
        return { ...previous, [clinicId]: availabilities[indexOfWeek] }
      }, {})

      const periodEmpty = isCurrentPeriodEmpty(newPeriod)

      return previousPeriodDifferentLength
        ? newPeriod
        : periodEmpty && indexOfFirstPeriodWithAvailabilities > 0 && indexOfWeek === 0
        ? clinicsAvailabilitiesWithFirstPeriod
        : undefined
    }

    return clinicsAvailabilitiesWithFirstPeriod
  }
}

const getIndexOfFirstPeriodWithAvailabilities = (
  clinicsAvailabilities: AllClinicsAvailabilitiesGroupedByPeriod
): number => {
  let indexOfPeriod: number | null = null
  Object.entries(clinicsAvailabilities).forEach(([id, clinicAvailabilities]) => {
    const indexOfPeriodWithAvailabilities = clinicAvailabilities.findIndex((week) =>
      week.some((day) => day.availabilities.length > 0)
    )
    if (indexOfPeriodWithAvailabilities !== -1) {
      if (!indexOfPeriod) indexOfPeriod = indexOfPeriodWithAvailabilities
      if (indexOfPeriodWithAvailabilities < indexOfPeriod) {
        indexOfPeriod = indexOfPeriodWithAvailabilities
      }
    }
  })

  return indexOfPeriod || 0
}
